import { render, staticRenderFns } from "./EmailHistoryDetail.vue?vue&type=template&id=0614afe5&scoped=true&"
import script from "./EmailHistoryDetail.vue?vue&type=script&lang=ts&"
export * from "./EmailHistoryDetail.vue?vue&type=script&lang=ts&"
import style0 from "./EmailHistoryDetail.vue?vue&type=style&index=0&id=0614afe5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0614afe5",
  null
  
)

export default component.exports